import IjtaiHero from "./components/IjtaiHero";
import IjtaiWhatIs from "./components/IjtaiWhatIs";
import IjtaiPublicationTypes from "./components/IjtaiPublicationTypes";
import IjtaiProcess from "./components/IjtaiProcess";
import IjtaiPathwayNav from "./components/IjtaiPathwayNav";
import IjtaiOutcomes from "./components/IjtaiOutcomes";

export default function Ijtai() {
  return (
    <main className="min-h-screen">
      <IjtaiHero />
      <IjtaiWhatIs />
      <IjtaiPublicationTypes />
      <IjtaiProcess />
      <IjtaiPathwayNav />
      <IjtaiOutcomes />
    </main>
  );
}